<template>
  <div class="ds-foro">
    <div class="ds-foro__item" v-for="item in foros" :key="item.Id">
      <div class="ds-foro__header">
        <div class="ds-foro__title-col">
          <div class="ds-foro__title ds-body-big-bold" @click="openPost(item.Id)">{{ item.Titulo }}</div>
        </div>
        <div class="ds-foro__messages" @click="openPost(item.Id)">
          <i class="el-icon-chat-line-square"></i>
          <span class="ds-foro__messages-count ds-body-medium">({{ item.CantidadComentarios }})</span>
        </div>
      </div>
      <div class="ds-foro__content">
        <div
          :ref="`desc-${item.Id}`"
          class="ds-foro__description"
          :class="{ 'is-collapsed': showReadMoreIds[item.Id] && !expandedIds[item.Id] }"
        >
          {{ item.Descripcion }}
        </div>
        <button
          v-if="showReadMoreIds[item.Id] && !expandedIds[item.Id]"
          type="button"
          class="ds-foro__read-more ds-body-small-bold"
          @click="expandDescription(item.Id)"
        >
          Leer mas <i class="el-icon-arrow-down"></i>
        </button>
        <button
          v-if="showReadMoreIds[item.Id] && expandedIds[item.Id]"
          type="button"
          class="ds-foro__read-more ds-body-small-bold"
          @click="collapseDescription(item.Id)"
        >
          Leer menos <i class="el-icon-arrow-up"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DsForo',
  props: {
    data: { type: Array, default: () => [] },
  },
  data() {
    return {
      foros: this.data,
      expandedIds: {},
      showReadMoreIds: {}
    }
  },
  watch: {
    data(newVal) {
      this.foros = newVal
      this.$nextTick(() => this.calculateOverflows())
    }
  },
  mounted() {
    this.$nextTick(() => this.calculateOverflows())
  },
  methods: {
    openPost(id) {
      this.$router.push({ name: 'Post', params: { id } })
    },
    expandDescription(id) {
      this.$set(this.expandedIds, id, true)
    },
    collapseDescription(id) {
      this.$set(this.expandedIds, id, false)
    },
    getRefElement(id) {
      const refValue = this.$refs[`desc-${id}`]
      return Array.isArray(refValue) ? refValue[0] : refValue
    },
    calculateOverflows() {
      const newShowReadMore = {}
      this.foros.forEach((foro) => {
        const element = this.getRefElement(foro.Id)
        if (!element) {
          return
        }

        const wasCollapsed = element.classList.contains('is-collapsed')
        if (wasCollapsed) {
          element.classList.remove('is-collapsed')
        }

        const lineHeight = parseFloat(window.getComputedStyle(element).lineHeight) || 18
        const maxAllowedHeight = lineHeight * 3
        newShowReadMore[foro.Id] = element.scrollHeight > maxAllowedHeight + 1

        if (wasCollapsed) {
          element.classList.add('is-collapsed')
        }
      })

      this.showReadMoreIds = newShowReadMore
    }
  }
}
</script>

<style scoped>
.ds-foro {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  width: 100%;
}

.ds-foro__item {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  padding: 16px;
  align-items: flex-start;
  gap: 8px;
  border-top: 2px solid var(--ds-color-brand-500, #01A5E5);
  background: #FFF;
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
  box-sizing: border-box;
  cursor: pointer;
}

.ds-foro__header {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
}

.ds-foro__content {
  width: 100%;
  text-align: left;
}

.ds-foro__title {
  flex: 1 0 0;
  color: var(--ds-color-neutral-950, #131316);
  margin-bottom: 0;
  display: block;
  text-align: left;
}

.ds-foro__title-col {
  display: flex;
}

.ds-foro__messages {
  display: inline-flex;
  margin-left: auto;
  justify-content: flex-end;
  align-items: center;
  gap: 6px;
  color: var(--ds-color-neutral-600, #52525B);
  text-align: left;
}

.ds-foro__messages i {
  color: var(--ds-color-neutral-600, #52525B);
}

.ds-foro__messages-count {
  color: var(--ds-color-neutral-600, #52525B);
}

.ds-foro__description {
  font-size: 14px;
  line-height: 18px;
  color: var(--ds-color-neutral-600, #52525B);
  align-self: stretch;
  text-align: left;
}

.ds-foro__description.is-collapsed {
  display: -webkit-box;
  line-clamp: 3;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  height: 54px;
}

.ds-foro__read-more {
  margin-top: 6px;
  padding: 0;
  border: 0;
  background: transparent;
  color: #5a5a5a;
  text-decoration: underline;
  cursor: pointer;
  text-align: left;
}
</style>
